import * as React from "react";
import type { SVGProps } from "react";
const SvgOnLowFloorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      d="M1.032 57.986h12.045c.554 0 1.002-.448 1.002-1.002V44.432h11.428c.553 0 1.002-.449 1.002-1.002V33.09h11.675c.554 0 1.002-.448 1.002-1.002V20.127h11.186c.554 0 1.002-.448 1.002-1.002V7.986h11.658a1.002 1.002 0 1 0 0-2.004H50.37c-.554 0-1.002.449-1.002 1.002v11.14H38.184c-.553 0-1.002.447-1.002 1.001v11.961H25.507c-.554 0-1.002.448-1.002 1.002v10.34H13.077c-.554 0-1.002.448-1.002 1.002v12.552H1.032a1.002 1.002 0 1 0 0 2.003zm55-17.966a.96.96 0 0 0-.682.282l-14.28 14.28v-9.599a1.038 1.038 0 1 0-2.075 0v12c0 .574.464 1.037 1.037 1.037h12a1.037 1.037 0 1 0 0-2.074h-9.6l14.28-14.28a.965.965 0 0 0-.68-1.646"
      data-original="#000000"
    />
  </svg>
);
export default SvgOnLowFloorIcon;
